import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { keyService } from '../api-services/keycloak/service/key.service';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import * as appConstants from '../../assets/json/applicationConstants.json';

/**
 * This component to display ayurls provide service like
 * therapy,Care Service,lifestyle management,diesase management.
 * A user can select this service and take the appointments.
 */

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  getToken: any = false;
  demo_address: any
  getId = 1;
  @ViewChild('msg') modalRef;


  constructor(private kc: keyService, private modalService: BsModalService, 
    private addressService: TalkToDoctorService) {
  }




  async ngOnInit() {
    this.getToken = await this.kc.isLoggedIn();
    this.addressService.getServiceAddress().subscribe(res => {
      this.demo_address = res;
      this.getId = this.demo_address[0].id;
    })
    $('.carousel-showmanymoveone .item').each(function () {
      var itemToClone = $(this);

      for (var i = 1; i < 6; i++) {
        itemToClone = itemToClone.next();

        // wrap around if at end of item collection
        if (!itemToClone.length) {
          itemToClone = $(this).siblings(':first');
        }

        // grab item, clone, add marker class, add to collection
        itemToClone.children(':first-child').clone()
          .addClass("cloneditem-" + (i))
          .appendTo($(this));
        function onClick(element) {
          document.getElementById("img01");
          document.getElementById("modal01").style.display = "block";
        }

      };
    }
    )
  }

  modalOpen() {
    this.modalService.show(this.modalRef, {
      backdrop: 'static',
      keyboard: false,
      initialState: {
        message: 'Disease mangement appointment should be access after login'
      }
    });
  }
  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
  };

}

